// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ClipsView.css - Specific styles for the clips view component */

.grouped-clips-container {
  margin-top: 1rem;
  width: 100%;
  overflow: visible;
}

.job-clip-group {
  margin-bottom: 2rem;
}

.job-id-header {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.clips-row {
  display: flex;
  overflow-x: auto;
  padding-bottom: 1.5rem;
  /* Use auto height instead of vh units to prevent separate scroll area */
  min-height: auto;
  align-items: flex-start;
  scrollbar-width: thin;
  scrollbar-color: #aaa #eee;
  gap: 0.5rem;
  -webkit-overflow-scrolling: touch;
}

.clips-row::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.clips-row::-webkit-scrollbar-track {
  background: #eee;
  border-radius: 10px;
}

.clips-row::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 10px;
}

.clip-thumbnail {
  min-width: 360px;
  max-width: 400px;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 15px;
  background: #fff;
  cursor: pointer;
  min-height: 640px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  /* Fix to prevent movement */
  transition: none;
  transform: none !important;
}

.clip-thumbnail.selected {
  border: 2px solid #007bff;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
  /* Fix to prevent movement */
  transform: none !important;
}

.clip-thumbnail:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  /* Fix to prevent movement */
  transform: none !important;
}

.video-preview {
  width: 100%;
  position: relative;
  padding-top: 0; /* Remove aspect ratio padding */
  height: 380px; /* Further increased height */
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 15px;
  background: transparent; /* Changed from #000 to transparent */
  box-shadow: none; /* Removed inset shadow */
  display: flex; /* Enable flexbox */
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
}

.video-preview video {
  position: static; /* Remove absolute positioning */
  width: 100%;
  height: 100%;
  object-fit: contain; /* Allow video to maintain aspect ratio */
  max-height: 100%;
  max-width: 100%;
  background: transparent; /* Ensure background is transparent */
}

.clip-info {
  padding: 5px 0;
  margin-top: auto;
}

.clip-number {
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 1rem;
  color: #333;
}

.clip-type {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 8px;
  background-color: #f5f5f5;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
}

.clip-download-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.clip-placeholder {
  width: 100%;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  border-radius: 3px;
  margin-bottom: 5px;
}

.clip-icon {
  font-size: 2rem;
  color: #999;
}

.no-clips-message {
  text-align: center;
  padding: 2rem;
  color: #666;
  border: 1px dashed #ccc;
  border-radius: 5px;
  margin: 1rem 0;
}

.no-clips-message p {
  margin: 0.5rem 0;
}

.no-clips-message .sub-message {
  font-size: 0.9rem;
  color: #999;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .clip-thumbnail {
    min-width: 320px;
    max-width: 100%;
    margin: 0 8px;
    min-height: 640px; /* Increased to accommodate taller video */
    padding: 10px; /* Slightly smaller padding on mobile */
  }
  
  .video-preview {
    height: 340px; /* Increased height on mobile as well */
    min-width: 100%;
    background: transparent; /* Ensure transparent background on mobile too */
  }
  
  .clips-row {
    /* Use auto height instead of fixed height to prevent separate scroll area */
    height: auto;
    min-height: auto;
    padding: 15px 0;
    align-items: flex-start;
  }
  
  .time-row,
  .duration-row,
  .score-row {
    padding: 8px 10px;
    margin-bottom: 8px;
  }
  
  .clip-heading-bar,
  .clip-caption-text {
    padding: 10px;
    margin-bottom: 8px;
    font-size: 13px;
  }
  
  .section-header {
    padding: 8px 10px;
    font-size: 13px;
  }
  
  .hashtags-list,
  .factors-list,
  .prompt-container,
  .hooks-container {
    padding: 10px;
    gap: 6px;
  }
  
  .factor-item,
  .hook-item,
  .prompt-quote {
    padding: 8px 10px;
    font-size: 12px;
  }
  
  .hashtag-pill {
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .copy-btn {
    padding: 3px 8px;
    font-size: 11px;
  }
  
  .clip-summary-row {
    padding: 4px 6px;
    font-size: 0.85rem;
  }
}

/* Add this CSS at the end of the file */

.variation-group {
  margin-bottom: 20px;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  padding: 10px;
  background-color: #f9f9f9;
}

.variation-header {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #555;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}

.job-clip-group {
  margin-bottom: 30px;
}

.job-id-header {
  margin-bottom: 15px;
  font-size: 18px;
  color: #333;
  border-bottom: 2px solid #007bff;
  padding-bottom: 8px;
}

/* Add CSS for the variation badge */
.variation-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 2;
}

.clip-count {
  font-size: 14px;
  font-weight: normal;
  color: #666;
  margin-left: 8px;
}

/* Clip time indicators */
.clip-time-indicators {
  display: flex;
  flex-direction: column;
  padding: 8px;
  background-color: #f9f9f9;
  border-radius: 6px;
  margin: 8px 0;
  font-size: 12px;
  border: 1px solid #eee;
  gap: 6px;
}

.clip-time-indicator {
  cursor: pointer;
  padding: 6px 8px;
  background-color: white;
  border-radius: 4px;
  transition: background-color 0.2s, transform 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #eee;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.clip-time-indicator:hover {
  background-color: rgba(0, 123, 255, 0.1);
  transform: translateY(-1px);
}

.clip-time-indicator.start-time {
  border-left: 3px solid #4CAF50;
}

.clip-time-indicator.end-time {
  border-left: 3px solid #F44336;
}

.clip-time-indicator .time-label {
  font-weight: bold;
  color: #555;
  font-size: 10px;
  text-transform: uppercase;
}

.clip-time-indicator .time-value {
  color: #333;
  font-family: monospace;
  background-color: #f0f0f0;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 11px;
}

.clip-viral-score {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  background-color: white;
  border-radius: 4px;
  margin-top: 4px;
  border: 1px solid #eee;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.score-label {
  font-weight: bold;
  color: #555;
  font-size: 10px;
  text-transform: uppercase;
}

.score-value {
  color: white;
  background-color: #2196F3;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: bold;
}

.clip-heading {
  padding: 8px;
  margin-top: 8px;
  background-color: #e3f2fd;
  border-radius: 4px;
  border-left: 3px solid #1976d2;
}

.heading-value {
  font-size: 13px;
  font-weight: 500;
  color: #1565C0;
  line-height: 1.4;
}

.clip-caption {
  padding: 8px;
  margin-top: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border-left: 3px solid #9e9e9e;
}

.caption-value {
  font-size: 12px;
  color: #616161;
  line-height: 1.4;
  font-style: italic;
}

/* Viral factors section */
.clip-viral-factors {
  padding: 8px;
  margin-top: 8px;
  background-color: #fff3e0;
  border-radius: 4px;
  border-left: 3px solid #ff9800;
}

.factors-label {
  display: block;
  font-weight: bold;
  font-size: 10px;
  color: #e65100;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.factors-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.factor-item {
  background-color: white;
  border: 1px solid #ffcc80;
  border-radius: 4px;
  padding: 8px 36px 8px 12px;
  color: #e65100;
  font-size: 13px;
  position: relative;
}

.factor-more {
  font-size: 10px;
  color: #e65100;
  opacity: 0.7;
  margin-left: 4px;
}

/* Hashtags section */
.clip-hashtags {
  padding: 8px;
  margin-top: 8px;
  background-color: #e8f5e9;
  border-radius: 4px;
  border-left: 3px solid #4caf50;
}

.hashtags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.hashtag-item {
  background-color: #c8e6c9;
  border: 1px solid #a5d6a7;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 10px;
  color: #2e7d32;
  font-weight: bold;
}

.hashtag-more {
  font-size: 10px;
  color: #2e7d32;
  opacity: 0.7;
  margin-left: 4px;
}

/* Engagement prompts section */
.clip-prompts {
  padding: 8px;
  margin-top: 8px;
  background-color: #e3f2fd;
  border-radius: 4px;
  border-left: 3px solid #2196f3;
}

.prompts-label {
  display: block;
  font-weight: bold;
  font-size: 10px;
  color: #0d47a1;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.prompts-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.prompt-item {
  background-color: #bbdefb;
  border: 1px solid #90caf9;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 11px;
  color: #0d47a1;
  font-style: italic;
  line-height: 1.3;
}

.prompts-more {
  font-size: 10px;
  color: #0d47a1;
  opacity: 0.7;
  text-align: right;
  margin-top: 4px;
}

/* Duration section */
.clip-duration {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-top: 8px;
  border: 1px solid #eee;
}

.duration-label {
  font-weight: bold;
  color: #555;
  font-size: 10px;
  text-transform: uppercase;
}

.duration-value {
  color: #333;
  font-family: monospace;
  background-color: #e0e0e0;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: bold;
}

/* Clip Details */
.clip-details {
  margin-top: 10px;
  font-size: 13px;
}

/* Time rows for START and END */
.time-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-left-width: 5px;
  border-left-style: solid;
  background-color: #f5f5f5;
  margin-bottom: 10px;
  cursor: pointer;
  border-radius: 0 4px 4px 0;
}

.time-row.start-time {
  border-left-color: #4CAF50;
}

.time-row.end-time {
  border-left-color: #F44336;
}

.time-label {
  font-weight: bold;
  color: #555;
  letter-spacing: 0.5px;
  font-size: 14px;
}

.time-value {
  font-family: monospace;
  letter-spacing: 0.5px;
  font-size: 14px;
  padding: 4px 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

/* Duration display in min:sec format */
.duration-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f5f5;
  margin-bottom: 10px;
  border-radius: 4px;
  border-left: 5px solid #9C27B0;
}

.section-header {
  background-color: #f5f5f5;
  padding: 10px 15px;
  font-weight: bold;
  color: #333;
  font-size: 14px;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Copy button for hashtags */
.copy-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  font-weight: bold;
}

/* Hashtags section */
.hashtags-section {
  margin: 15px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.hashtags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 15px;
  background-color: #f9f9f9;
}

.hashtag-pill {
  background-color: #dcedc8;
  border: 1px solid #aed581;
  color: #33691e;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
}

/* Viral Factors Section */
.factors-section {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 15px 0;
  overflow: hidden;
}

.factors-list {
  padding: 15px;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.factor-item {
  background-color: white;
  border: 1px solid #ffcc80;
  border-radius: 4px;
  padding: 8px 36px 8px 12px;
  color: #e65100;
  font-size: 13px;
  position: relative;
}

/* Engagement Prompts Section */
.prompts-section {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 15px 0;
  overflow: hidden;
}

.prompt-container {
  padding: 15px;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.prompt-quote {
  background-color: white;
  border-left: 3px solid #2196f3;
  padding: 10px 36px 10px 12px;
  font-style: italic;
  color: #0d47a1;
  font-size: 13px;
  line-height: 1.4;
  border-radius: 0 4px 4px 0;
  position: relative;
}

/* Hook Suggestions */
.hooks-section {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 15px 0;
  overflow: hidden;
}

.hooks-container {
  padding: 15px;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.hook-item {
  background-color: white;
  border-left: 3px solid #ff9800;
  padding: 10px 36px 10px 12px;
  color: #e65100;
  font-size: 13px;
  line-height: 1.4;
  border-radius: 0 4px 4px 0;
  position: relative;
}

/* Show More Link */
.show-more {
  text-align: center;
  color: #777;
  font-size: 12px;
  padding: 5px;
  cursor: pointer;
}

.show-more:hover {
  text-decoration: underline;
  color: #555;
}

/* Duration Label */
.duration-label {
  display: inline-block;
  background-color: #f5f5f5;
  padding: 4px 10px;
  border-radius: 15px;
  font-size: 12px;
  color: #555;
  margin: 10px 0;
  font-weight: 500;
}

.duration-value {
  font-weight: bold;
  color: #333;
}

/* Viral Score Section */
.score-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.score-label {
  font-weight: bold;
  color: #666;
  letter-spacing: 0.5px;
  font-size: 14px;
}

.score-badge {
  background-color: #2196F3;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 14px;
  min-width: 50px;
  text-align: center;
}

/* Heading and Caption */
.clip-heading-bar {
  background-color: #e3f2fd;
  color: #1565C0;
  padding: 12px 15px;
  font-weight: bold;
  font-size: 15px;
  border-left: 5px solid #1976d2;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.clip-caption-text {
  font-style: italic;
  color: #666;
  padding: 12px 15px;
  background-color: #f9f9f9;
  border-left: 5px solid #9e9e9e;
  margin-bottom: 15px;
  line-height: 1.4;
  font-size: 14px;
  border-radius: 0 4px 4px 0;
}

/* Clip content container */
.clip-content-container {
  display: flex;
  flex-direction: column;
  gap: 15px; /* Added gap for better spacing */
  width: 100%; /* Ensure full width */
}

/* Clip Summary Row */
.clip-summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 15px;
  font-weight: bold;
}

.clip-number {
  color: #333;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.clip-summary-score {
  background-color: #2196F3;
  color: white;
  padding: 4px 10px;
  border-radius: 15px;
  font-size: 14px;
  text-align: center;
}

.clip-summary-duration {
  background-color: #9C27B0;
  color: white;
  padding: 4px 10px;
  border-radius: 15px;
  font-size: 14px;
  font-family: monospace;
}

/* Content Expander */
.content-expander {
  margin-bottom: 10px;
}

.toggle-content-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  cursor: pointer;
  transition: background-color 0.2s;
}

.toggle-content-btn:hover {
  background-color: #f0f0f0;
}

.toggle-icon {
  font-size: 10px;
  transition: transform 0.2s;
}

.collapsed .toggle-icon {
  transform: rotate(-90deg);
}

/* When collapsed, hide all direct children except the expander */
.clip-content-container.collapsed > *:not(.content-expander) {
  display: none;
}

/* Media query for mobile */
@media (max-width: 768px) {
  .toggle-content-btn {
    padding: 6px 10px;
    font-size: 13px;
  }
}

/* Expandable Sections */
.expandable-section {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 15px;
  overflow: hidden;
}

.expandable-section .section-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.section-toggle {
  font-size: 10px;
  margin-left: 8px;
  transition: transform 0.2s;
}

.expandable-section.collapsed .section-toggle {
  transform: rotate(-90deg);
}

.expandable-section.collapsed .section-content {
  display: none;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Update section-header to be more clickable */
.section-header {
  background-color: #f5f5f5;
  padding: 10px 15px;
  font-weight: bold;
  color: #333;
  font-size: 14px;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;
}

.section-header:hover {
  background-color: #eaeaea;
}

/* Individual item copy buttons */
.factor-item,
.prompt-quote,
.hook-item {
  position: relative;
  padding-right: 36px; /* Make room for copy button */
}

.copy-item-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  font-size: 14px;
  padding: 4px;
  cursor: pointer;
  opacity: 0.3;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.copy-item-btn:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.05);
  transform: translateY(-50%) scale(1.1);
}

.factor-item:hover .copy-item-btn,
.prompt-quote:hover .copy-item-btn,
.hook-item:hover .copy-item-btn {
  opacity: 0.7;
}

.copy-icon {
  font-size: 16px;
}

/* Toast notifications */
.copy-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%) translateY(100px);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  max-width: 80%;
  text-align: center;
  z-index: 10000;
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;
  pointer-events: none;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}

.copy-toast.visible {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

@media (max-width: 768px) {
  .copy-toast {
    font-size: 12px;
    padding: 8px 16px;
    max-width: 90%;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/css/ClipsView.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,wEAAwE;EACxE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc,EAAE,gCAAgC;EAChD,aAAa,EAAE,6BAA6B;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB,EAAE,qCAAqC;EAC9D,gBAAgB,EAAE,yBAAyB;EAC3C,aAAa,EAAE,mBAAmB;EAClC,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,yCAAyC;EAC9D,gBAAgB;EAChB,eAAe;EACf,uBAAuB,EAAE,qCAAqC;AAChE;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,iBAAiB,EAAE,0CAA0C;IAC7D,aAAa,EAAE,uCAAuC;EACxD;;EAEA;IACE,aAAa,EAAE,uCAAuC;IACtD,eAAe;IACf,uBAAuB,EAAE,gDAAgD;EAC3E;;EAEA;IACE,4EAA4E;IAC5E,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,uBAAuB;EACzB;;EAEA;;;IAGE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;;;IAIE,aAAa;IACb,QAAQ;EACV;;EAEA;;;IAGE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,wCAAwC;;AAExC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,iCAAiC;EAC5C,WAAW,EAAE,sBAAsB;AACrC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;;;EAGE,kBAAkB;EAClB,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,6CAA6C;EAC7C,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;AACF","sourcesContent":["/* ClipsView.css - Specific styles for the clips view component */\n\n.grouped-clips-container {\n  margin-top: 1rem;\n  width: 100%;\n  overflow: visible;\n}\n\n.job-clip-group {\n  margin-bottom: 2rem;\n}\n\n.job-id-header {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.clips-row {\n  display: flex;\n  overflow-x: auto;\n  padding-bottom: 1.5rem;\n  /* Use auto height instead of vh units to prevent separate scroll area */\n  min-height: auto;\n  align-items: flex-start;\n  scrollbar-width: thin;\n  scrollbar-color: #aaa #eee;\n  gap: 0.5rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.clips-row::-webkit-scrollbar {\n  height: 8px;\n  width: 8px;\n}\n\n.clips-row::-webkit-scrollbar-track {\n  background: #eee;\n  border-radius: 10px;\n}\n\n.clips-row::-webkit-scrollbar-thumb {\n  background: #aaa;\n  border-radius: 10px;\n}\n\n.clip-thumbnail {\n  min-width: 360px;\n  max-width: 400px;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  padding: 15px;\n  background: #fff;\n  cursor: pointer;\n  min-height: 640px;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  /* Fix to prevent movement */\n  transition: none;\n  transform: none !important;\n}\n\n.clip-thumbnail.selected {\n  border: 2px solid #007bff;\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);\n  /* Fix to prevent movement */\n  transform: none !important;\n}\n\n.clip-thumbnail:hover {\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  /* Fix to prevent movement */\n  transform: none !important;\n}\n\n.video-preview {\n  width: 100%;\n  position: relative;\n  padding-top: 0; /* Remove aspect ratio padding */\n  height: 380px; /* Further increased height */\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 15px;\n  background: transparent; /* Changed from #000 to transparent */\n  box-shadow: none; /* Removed inset shadow */\n  display: flex; /* Enable flexbox */\n  justify-content: center; /* Center horizontally */\n  align-items: center; /* Center vertically */\n}\n\n.video-preview video {\n  position: static; /* Remove absolute positioning */\n  width: 100%;\n  height: 100%;\n  object-fit: contain; /* Allow video to maintain aspect ratio */\n  max-height: 100%;\n  max-width: 100%;\n  background: transparent; /* Ensure background is transparent */\n}\n\n.clip-info {\n  padding: 5px 0;\n  margin-top: auto;\n}\n\n.clip-number {\n  font-weight: bold;\n  margin-bottom: 5px;\n  font-size: 1rem;\n  color: #333;\n}\n\n.clip-type {\n  font-size: 0.85rem;\n  color: #666;\n  margin-bottom: 8px;\n  background-color: #f5f5f5;\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.clip-download-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.clip-placeholder {\n  width: 100%;\n  height: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f0f0f0;\n  border-radius: 3px;\n  margin-bottom: 5px;\n}\n\n.clip-icon {\n  font-size: 2rem;\n  color: #999;\n}\n\n.no-clips-message {\n  text-align: center;\n  padding: 2rem;\n  color: #666;\n  border: 1px dashed #ccc;\n  border-radius: 5px;\n  margin: 1rem 0;\n}\n\n.no-clips-message p {\n  margin: 0.5rem 0;\n}\n\n.no-clips-message .sub-message {\n  font-size: 0.9rem;\n  color: #999;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .clip-thumbnail {\n    min-width: 320px;\n    max-width: 100%;\n    margin: 0 8px;\n    min-height: 640px; /* Increased to accommodate taller video */\n    padding: 10px; /* Slightly smaller padding on mobile */\n  }\n  \n  .video-preview {\n    height: 340px; /* Increased height on mobile as well */\n    min-width: 100%;\n    background: transparent; /* Ensure transparent background on mobile too */\n  }\n  \n  .clips-row {\n    /* Use auto height instead of fixed height to prevent separate scroll area */\n    height: auto;\n    min-height: auto;\n    padding: 15px 0;\n    align-items: flex-start;\n  }\n  \n  .time-row,\n  .duration-row,\n  .score-row {\n    padding: 8px 10px;\n    margin-bottom: 8px;\n  }\n  \n  .clip-heading-bar,\n  .clip-caption-text {\n    padding: 10px;\n    margin-bottom: 8px;\n    font-size: 13px;\n  }\n  \n  .section-header {\n    padding: 8px 10px;\n    font-size: 13px;\n  }\n  \n  .hashtags-list,\n  .factors-list,\n  .prompt-container,\n  .hooks-container {\n    padding: 10px;\n    gap: 6px;\n  }\n  \n  .factor-item,\n  .hook-item,\n  .prompt-quote {\n    padding: 8px 10px;\n    font-size: 12px;\n  }\n  \n  .hashtag-pill {\n    font-size: 11px;\n    padding: 4px 8px;\n  }\n  \n  .copy-btn {\n    padding: 3px 8px;\n    font-size: 11px;\n  }\n  \n  .clip-summary-row {\n    padding: 4px 6px;\n    font-size: 0.85rem;\n  }\n}\n\n/* Add this CSS at the end of the file */\n\n.variation-group {\n  margin-bottom: 20px;\n  border: 1px solid #eaeaea;\n  border-radius: 5px;\n  padding: 10px;\n  background-color: #f9f9f9;\n}\n\n.variation-header {\n  margin: 0 0 10px 0;\n  font-size: 16px;\n  color: #555;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 5px;\n}\n\n.job-clip-group {\n  margin-bottom: 30px;\n}\n\n.job-id-header {\n  margin-bottom: 15px;\n  font-size: 18px;\n  color: #333;\n  border-bottom: 2px solid #007bff;\n  padding-bottom: 8px;\n}\n\n/* Add CSS for the variation badge */\n.variation-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  z-index: 2;\n}\n\n.clip-count {\n  font-size: 14px;\n  font-weight: normal;\n  color: #666;\n  margin-left: 8px;\n}\n\n/* Clip time indicators */\n.clip-time-indicators {\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  margin: 8px 0;\n  font-size: 12px;\n  border: 1px solid #eee;\n  gap: 6px;\n}\n\n.clip-time-indicator {\n  cursor: pointer;\n  padding: 6px 8px;\n  background-color: white;\n  border-radius: 4px;\n  transition: background-color 0.2s, transform 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #eee;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.clip-time-indicator:hover {\n  background-color: rgba(0, 123, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n.clip-time-indicator.start-time {\n  border-left: 3px solid #4CAF50;\n}\n\n.clip-time-indicator.end-time {\n  border-left: 3px solid #F44336;\n}\n\n.clip-time-indicator .time-label {\n  font-weight: bold;\n  color: #555;\n  font-size: 10px;\n  text-transform: uppercase;\n}\n\n.clip-time-indicator .time-value {\n  color: #333;\n  font-family: monospace;\n  background-color: #f0f0f0;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-size: 11px;\n}\n\n.clip-viral-score {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 8px;\n  background-color: white;\n  border-radius: 4px;\n  margin-top: 4px;\n  border: 1px solid #eee;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.score-label {\n  font-weight: bold;\n  color: #555;\n  font-size: 10px;\n  text-transform: uppercase;\n}\n\n.score-value {\n  color: white;\n  background-color: #2196F3;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.clip-heading {\n  padding: 8px;\n  margin-top: 8px;\n  background-color: #e3f2fd;\n  border-radius: 4px;\n  border-left: 3px solid #1976d2;\n}\n\n.heading-value {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1565C0;\n  line-height: 1.4;\n}\n\n.clip-caption {\n  padding: 8px;\n  margin-top: 8px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  border-left: 3px solid #9e9e9e;\n}\n\n.caption-value {\n  font-size: 12px;\n  color: #616161;\n  line-height: 1.4;\n  font-style: italic;\n}\n\n/* Viral factors section */\n.clip-viral-factors {\n  padding: 8px;\n  margin-top: 8px;\n  background-color: #fff3e0;\n  border-radius: 4px;\n  border-left: 3px solid #ff9800;\n}\n\n.factors-label {\n  display: block;\n  font-weight: bold;\n  font-size: 10px;\n  color: #e65100;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.factors-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.factor-item {\n  background-color: white;\n  border: 1px solid #ffcc80;\n  border-radius: 4px;\n  padding: 8px 36px 8px 12px;\n  color: #e65100;\n  font-size: 13px;\n  position: relative;\n}\n\n.factor-more {\n  font-size: 10px;\n  color: #e65100;\n  opacity: 0.7;\n  margin-left: 4px;\n}\n\n/* Hashtags section */\n.clip-hashtags {\n  padding: 8px;\n  margin-top: 8px;\n  background-color: #e8f5e9;\n  border-radius: 4px;\n  border-left: 3px solid #4caf50;\n}\n\n.hashtags-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.hashtag-item {\n  background-color: #c8e6c9;\n  border: 1px solid #a5d6a7;\n  border-radius: 12px;\n  padding: 2px 8px;\n  font-size: 10px;\n  color: #2e7d32;\n  font-weight: bold;\n}\n\n.hashtag-more {\n  font-size: 10px;\n  color: #2e7d32;\n  opacity: 0.7;\n  margin-left: 4px;\n}\n\n/* Engagement prompts section */\n.clip-prompts {\n  padding: 8px;\n  margin-top: 8px;\n  background-color: #e3f2fd;\n  border-radius: 4px;\n  border-left: 3px solid #2196f3;\n}\n\n.prompts-label {\n  display: block;\n  font-weight: bold;\n  font-size: 10px;\n  color: #0d47a1;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.prompts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.prompt-item {\n  background-color: #bbdefb;\n  border: 1px solid #90caf9;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 11px;\n  color: #0d47a1;\n  font-style: italic;\n  line-height: 1.3;\n}\n\n.prompts-more {\n  font-size: 10px;\n  color: #0d47a1;\n  opacity: 0.7;\n  text-align: right;\n  margin-top: 4px;\n}\n\n/* Duration section */\n.clip-duration {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 8px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  margin-top: 8px;\n  border: 1px solid #eee;\n}\n\n.duration-label {\n  font-weight: bold;\n  color: #555;\n  font-size: 10px;\n  text-transform: uppercase;\n}\n\n.duration-value {\n  color: #333;\n  font-family: monospace;\n  background-color: #e0e0e0;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n/* Clip Details */\n.clip-details {\n  margin-top: 10px;\n  font-size: 13px;\n}\n\n/* Time rows for START and END */\n.time-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  border-left-width: 5px;\n  border-left-style: solid;\n  background-color: #f5f5f5;\n  margin-bottom: 10px;\n  cursor: pointer;\n  border-radius: 0 4px 4px 0;\n}\n\n.time-row.start-time {\n  border-left-color: #4CAF50;\n}\n\n.time-row.end-time {\n  border-left-color: #F44336;\n}\n\n.time-label {\n  font-weight: bold;\n  color: #555;\n  letter-spacing: 0.5px;\n  font-size: 14px;\n}\n\n.time-value {\n  font-family: monospace;\n  letter-spacing: 0.5px;\n  font-size: 14px;\n  padding: 4px 8px;\n  background-color: #e0e0e0;\n  border-radius: 4px;\n}\n\n/* Duration display in min:sec format */\n.duration-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  margin-bottom: 10px;\n  border-radius: 4px;\n  border-left: 5px solid #9C27B0;\n}\n\n.section-header {\n  background-color: #f5f5f5;\n  padding: 10px 15px;\n  font-weight: bold;\n  color: #333;\n  font-size: 14px;\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Copy button for hashtags */\n.copy-btn {\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n/* Hashtags section */\n.hashtags-section {\n  margin: 15px 0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.hashtags-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 15px;\n  background-color: #f9f9f9;\n}\n\n.hashtag-pill {\n  background-color: #dcedc8;\n  border: 1px solid #aed581;\n  color: #33691e;\n  padding: 5px 10px;\n  border-radius: 15px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* Viral Factors Section */\n.factors-section {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin: 15px 0;\n  overflow: hidden;\n}\n\n.factors-list {\n  padding: 15px;\n  background-color: #f9f9f9;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.factor-item {\n  background-color: white;\n  border: 1px solid #ffcc80;\n  border-radius: 4px;\n  padding: 8px 36px 8px 12px;\n  color: #e65100;\n  font-size: 13px;\n  position: relative;\n}\n\n/* Engagement Prompts Section */\n.prompts-section {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin: 15px 0;\n  overflow: hidden;\n}\n\n.prompt-container {\n  padding: 15px;\n  background-color: #f9f9f9;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.prompt-quote {\n  background-color: white;\n  border-left: 3px solid #2196f3;\n  padding: 10px 36px 10px 12px;\n  font-style: italic;\n  color: #0d47a1;\n  font-size: 13px;\n  line-height: 1.4;\n  border-radius: 0 4px 4px 0;\n  position: relative;\n}\n\n/* Hook Suggestions */\n.hooks-section {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin: 15px 0;\n  overflow: hidden;\n}\n\n.hooks-container {\n  padding: 15px;\n  background-color: #f9f9f9;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.hook-item {\n  background-color: white;\n  border-left: 3px solid #ff9800;\n  padding: 10px 36px 10px 12px;\n  color: #e65100;\n  font-size: 13px;\n  line-height: 1.4;\n  border-radius: 0 4px 4px 0;\n  position: relative;\n}\n\n/* Show More Link */\n.show-more {\n  text-align: center;\n  color: #777;\n  font-size: 12px;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.show-more:hover {\n  text-decoration: underline;\n  color: #555;\n}\n\n/* Duration Label */\n.duration-label {\n  display: inline-block;\n  background-color: #f5f5f5;\n  padding: 4px 10px;\n  border-radius: 15px;\n  font-size: 12px;\n  color: #555;\n  margin: 10px 0;\n  font-weight: 500;\n}\n\n.duration-value {\n  font-weight: bold;\n  color: #333;\n}\n\n/* Viral Score Section */\n.score-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f5f5f5;\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  border-radius: 4px;\n}\n\n.score-label {\n  font-weight: bold;\n  color: #666;\n  letter-spacing: 0.5px;\n  font-size: 14px;\n}\n\n.score-badge {\n  background-color: #2196F3;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-weight: bold;\n  font-size: 14px;\n  min-width: 50px;\n  text-align: center;\n}\n\n/* Heading and Caption */\n.clip-heading-bar {\n  background-color: #e3f2fd;\n  color: #1565C0;\n  padding: 12px 15px;\n  font-weight: bold;\n  font-size: 15px;\n  border-left: 5px solid #1976d2;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.clip-caption-text {\n  font-style: italic;\n  color: #666;\n  padding: 12px 15px;\n  background-color: #f9f9f9;\n  border-left: 5px solid #9e9e9e;\n  margin-bottom: 15px;\n  line-height: 1.4;\n  font-size: 14px;\n  border-radius: 0 4px 4px 0;\n}\n\n/* Clip content container */\n.clip-content-container {\n  display: flex;\n  flex-direction: column;\n  gap: 15px; /* Added gap for better spacing */\n  width: 100%; /* Ensure full width */\n}\n\n/* Clip Summary Row */\n.clip-summary-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  font-weight: bold;\n}\n\n.clip-number {\n  color: #333;\n  font-size: 14px;\n  letter-spacing: 0.5px;\n}\n\n.clip-summary-score {\n  background-color: #2196F3;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 15px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.clip-summary-duration {\n  background-color: #9C27B0;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 15px;\n  font-size: 14px;\n  font-family: monospace;\n}\n\n/* Content Expander */\n.content-expander {\n  margin-bottom: 10px;\n}\n\n.toggle-content-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #f8f8f8;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 8px 12px;\n  width: 100%;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 500;\n  color: #444;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.toggle-content-btn:hover {\n  background-color: #f0f0f0;\n}\n\n.toggle-icon {\n  font-size: 10px;\n  transition: transform 0.2s;\n}\n\n.collapsed .toggle-icon {\n  transform: rotate(-90deg);\n}\n\n/* When collapsed, hide all direct children except the expander */\n.clip-content-container.collapsed > *:not(.content-expander) {\n  display: none;\n}\n\n/* Media query for mobile */\n@media (max-width: 768px) {\n  .toggle-content-btn {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n}\n\n/* Expandable Sections */\n.expandable-section {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  overflow: hidden;\n}\n\n.expandable-section .section-header {\n  cursor: pointer;\n  user-select: none;\n}\n\n.section-toggle {\n  font-size: 10px;\n  margin-left: 8px;\n  transition: transform 0.2s;\n}\n\n.expandable-section.collapsed .section-toggle {\n  transform: rotate(-90deg);\n}\n\n.expandable-section.collapsed .section-content {\n  display: none;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Update section-header to be more clickable */\n.section-header {\n  background-color: #f5f5f5;\n  padding: 10px 15px;\n  font-weight: bold;\n  color: #333;\n  font-size: 14px;\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s;\n}\n\n.section-header:hover {\n  background-color: #eaeaea;\n}\n\n/* Individual item copy buttons */\n.factor-item,\n.prompt-quote,\n.hook-item {\n  position: relative;\n  padding-right: 36px; /* Make room for copy button */\n}\n\n.copy-item-btn {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  font-size: 14px;\n  padding: 4px;\n  cursor: pointer;\n  opacity: 0.3;\n  transition: opacity 0.2s, transform 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.copy-item-btn:hover {\n  opacity: 1;\n  background-color: rgba(0, 0, 0, 0.05);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.factor-item:hover .copy-item-btn,\n.prompt-quote:hover .copy-item-btn,\n.hook-item:hover .copy-item-btn {\n  opacity: 0.7;\n}\n\n.copy-icon {\n  font-size: 16px;\n}\n\n/* Toast notifications */\n.copy-toast {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%) translateY(100px);\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 14px;\n  max-width: 80%;\n  text-align: center;\n  z-index: 10000;\n  opacity: 0;\n  transition: opacity 0.3s, transform 0.3s;\n  pointer-events: none;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\n}\n\n.copy-toast.visible {\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n}\n\n@media (max-width: 768px) {\n  .copy-toast {\n    font-size: 12px;\n    padding: 8px 16px;\n    max-width: 90%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
